import { AxiosInstance } from 'axios';
import { getExportConfig, handleFileExport } from '../../../../../../helpers/fileExport';
import { ROOM_STATE_REPORT_ENDPOINT } from '../endpoint';
import { RoomStateReportRequestModel } from '../models/ArrivalReportRequestModel';

export const exportPDF =
  (axios: AxiosInstance) =>
  async (params?: RoomStateReportRequestModel): Promise<void> => {
    return await axios
      .get(`${ROOM_STATE_REPORT_ENDPOINT}`, {
        params: { ...params },
        ...getExportConfig(params),
      })
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'room-state-report',
        });
      });
  };
